import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Highlight from './Highlight';

function getColorFromProps({ color }) {
  return color;
}

function getBorderFromProps({ outlined, color }) {
  if (!outlined) return 'none';

  return `3px solid ${getColorFromProps({ color })}`;
}

const Root = styled.span`
  display: flex;
  cursor: pointer;
  overflow: hidden;
  line-height: 21px;
  text-align: center;
  padding: 12px 24px;
  position: relative;
  border-radius: 4px;
  align-items: center;
  box-sizing: border-box;
  justify-content: center;
  color: ${getColorFromProps};
  border: ${getBorderFromProps};
  font-size: ${props => (props.big ? 24 : 16)}px;
  font-weight: ${props => (props.thin ? 300 : 900)};
`;

const OutlinedButton = React.forwardRef(
  (
    {
      big,
      thin,
      color,
      onClick,
      children,
      outlined,
      disabled,
      className,
    },
    ref
  ) => {
    return (
      <Root
        className={className}
        outlined={outlined}
        disabled={disabled}
        onClick={onClick}
        color={color}
        thin={thin}
        ref={ref}
        big={big}
      >
        {children}
        <Highlight disabled={disabled} />
      </Root>
    );
  }
);

OutlinedButton.propTypes = {
  big: PropTypes.bool,
  thin: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  color: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  outlined: PropTypes.bool,
  className: PropTypes.string,
};

OutlinedButton.defaultProps = {
  big: false,
  thin: false,
  onClick: null,
  className: '',
  disabled: false,
  outlined: false,
  color: '#37474f',
};

export default OutlinedButton;
